import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function fetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CHANNEL_MAPPING_FETCHING:
      return true;
    case actions.SET_CHANNEL_MAPPING:
      return false;
    // case actions.SET_CHANNEL_COLLECT:
    //   return false;
    case actions.SET_API_FAIL:
      return false;
    case actions.SET_PUBLISH_RESULT:
      return false;
    default:
      return state;
  }
}
